import { defineStore } from "pinia";
import { PushNotifications, PushNotificationSchema, Token } from "@capacitor/push-notifications";
import useApiClient from "@cosine/composables/useApiClient";
import { DevicePlatform, IApiResponse, INativePushDeviceModel } from "@cosine/lib/api-models";
import { detectOS } from "@cosine/lib/utils/system/detectOS";
import { OS } from "@cosine/lib/utils/system/detectOS.types";
import { detectPlatform } from "@cosine/lib/utils/system/detectPlatform";
import { Platform } from "@cosine/lib/utils/system/detectPlatform.types";
import { ref } from "vue";

export default defineStore("PushNotificationStore", () => {
  const deviceToken = ref<string | null>(null);

  const isMobileNative = detectPlatform() === Platform.MobileNative;

  const {
    apiClient,
  } = useApiClient();

  const osPlatformMap: Record<OS, DevicePlatform | null> = {
    [OS.iOS]: DevicePlatform.Ios,
    [OS.Android]: DevicePlatform.Android,
    [OS.Other]: null,
  };

  const platform = osPlatformMap[detectOS()];

  function addPushNotificationListeners () {
    if (!isMobileNative) return;

    PushNotifications.addListener("registration", handleRegistration);

    PushNotifications.addListener(
      "pushNotificationReceived",
      handleInAppNotification,
    );
  }

  function removePushNotificationListeners () {
    if (!isMobileNative) return;
    PushNotifications.removeAllListeners();
  }

  async function requestPushNotificationPermissions () {
    if (!isMobileNative) return;

    const permissions = await PushNotifications.requestPermissions();
    if (permissions.receive === "granted") {
      PushNotifications.register();
    }
  }

  async function handleRegistration (token: Token) {
    if (!platform) return;

    deviceToken.value = token.value;

    await apiClient.value.post<IApiResponse<INativePushDeviceModel>>("/native-push-devices", {
      Token: token.value,
      Platform: platform,
    });
  }

  // TODO: Wire this up to our custom in-app banners
  function handleInAppNotification (notification: PushNotificationSchema) {
    alert("Push received: " + JSON.stringify(notification));
  }

  return {
    deviceToken,
    addPushNotificationListeners,
    removePushNotificationListeners,
    requestPushNotificationPermissions,
  };
});
